<template>
  <div>

<v-dialog v-model="history.clearAllModal" width="450" persistent>
  <v-card>
    <v-toolbar dark  color="#4A76A8" flat  height="42">
      <v-toolbar-title  > Удалить все процессы </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click="history.clearAllModal = false">mdi-close</v-icon>
    </v-toolbar>
<v-card-text>
Вы действительно хотите  удалить сохраненные процессы ? отменить данное действие будет невозможно
</v-card-text>


  <v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click="history.clearAllModal = false" flat small color="#4A76A8" >Отмена</v-btn>
  <v-btn :loading="history.clearAllBtnProcessModal" small color="red"  class="white--text" @click="historyClear()" >Удалить</v-btn>
  </v-card-actions>
  </v-card>

</v-dialog>












    <v-layout d-flex>
    <v-card>
      <v-toolbar height="42"   flat>
        <v-toolbar-title style="color:#273C51;font-size:1.6em"> Список процессов </v-toolbar-title>






        <v-spacer></v-spacer>


       <v-btn  v-if="history.foundData.length > 0" flat small @click="history.clearAllModal=true">
       <v-icon color="red" left> mdi-delete-forever </v-icon>
         Удалить всё

       </v-btn>
      </v-toolbar>




    <v-card-text>


      <v-select
      @change = "catData()"
      v-model = "history.lists.selectedCat"
      dense
      solo
      :items="history.lists.catList"
      >
        <template  v-if="history.lists.selectedCat !== 'Общий список'" slot="append" >
        <v-icon @click.stop="history.renameListModal = true" color="#273C51">mdi-pencil</v-icon>
        <v-icon @click="history.removeCatSelectedModal = true" color="red">mdi-close</v-icon>
        </template>
        <template slot="selection" >
        <span>  {{history.lists.selectedCat}}  ({{history.foundData.length }}) </span>
        </template>
        <template v-slot:item="{ item, attrs, on }">
        <v-list v-bind="attrs">
        <span v-if="item == history.lists.selectedCat" style="color:gray">  {{ item }} (текущий) </span>
        <span v-else>  {{ item }} </span>
        </v-list>
        </template>
      </v-select>


      <div>
   <historyList :history="history">  </historyList>
      </div>

      <div v-if="history.infModal">
   <infWrapper :history="history">  </infWrapper>
      </div>





    </v-card-text>


    </v-card>

    </v-layout>



<!--  Переименовать список -->
    <v-dialog v-model="history.renameListModal" scrollable max-width="350px">
        <v-card>

          <v-toolbar flat >
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title style="color:gray">    {{history.lists.selectedCat}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon style="cursor: pointer" color="#4A76A8" @click.native="history.renameListModal = false" >mdi-close</v-icon>
          </v-toolbar>

          <v-divider></v-divider>
          <v-card-text fluid   style="height: 300px;">
         <v-text-field
         v-model="history.lists.renameList.title"
         label="Новое название"
         >
         </v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#4A76A8" flat small   @click.native="history.renameCatSelectedModal = false">Закрыть</v-btn>
            <v-btn v-if='history.lists.renameList.title.length>0 ' :loading="history.lists.renameList.loading"  :disabled="history.lists.renameList.loading" color="#4A76A8" small class="white--text"  @click="renameCatList()">Изменить</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
<!--  Переименовать список  закрываем-->



<!--  Удалить  список -->
<v-dialog v-model="history.removeCatSelectedModal" scrollable max-width="350px">
    <v-card style="min-height:300px" >

      <v-toolbar flat >
      <v-icon>mdi-delete</v-icon>
      <v-toolbar-title style="color:gray">    {{history.lists.selectedCat}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon style="cursor: pointer" color="#4A76A8" @click.native="history.removeCatSelectedModal = false" >mdi-close</v-icon>
      </v-toolbar>

      <v-divider></v-divider>
      <v-card-text fluid   style="height: 300px;">
      Подтвердите удаление списка <span style="color:green">{{history.lists.selectedCat}}</span>,
      отменить данное действие будет невозможно, сообщества данного списка будут
      перенесены в общий список.
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#4A76A8" flat small   @click.native="history.removeCatSelectedModal = false">Закрыть</v-btn>
        <v-btn :loading="history.lists.removeList.loading"  :disabled="history.lists.removeList.loading" color="red" small class="white--text"  @click="deleteCatList()">Удалить</v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

<!--  УУдалить список закрытие-->

</div>
</template>

<script>
 import axios from 'axios'
 import historyList from './historyList.vue'
 import infWrapper from './infoWrapper.vue'
 export default {
components:{historyList,infWrapper},
     data () {
       return {
  history:{

    foundData: [],
    removeCatSelectedModal:false,
    renameListModal:false,
    clearAllModal:false,
    clearAllBtnProcessModal:false,
    infModal: false,

    lists: {
      renameList:{
        title: '',
        loading: false,
      },
      removeList:{
        loading: false,
      },
      selectedCat: 'Общий список',
      catList: [],
      modals:{
        renameCatSelected:false,
        removeCatSelected:false,
      },
    },

    selectedProc:{},

  },

  updaterInterval : true,


       }
     },
     methods:{
deleteCatList(){
  this.history.lists.removeList.loading = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/change_list.php',{
    method: 'POST',
    data: {
      type: 'delete',
      listName: this.history.lists.selectedCat,
    }
  })
  .then( response => {
    this.history.lists.catList.splice(this.history.lists.catList.indexOf(this.history.lists.selectedCat),1)
    this.history.lists.selectedCat = 'Общий список'

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/history_get_by_list.php', {
       method: 'POST',
       data : {catList:this.history.lists.catList, selectedCat:this.history.lists.selectedCat },
       }).then(response => {
   if(response.data.procs){
   this.history.foundData = response.data.procs
   this.history.lists.catList = response.data.catList
   this.history.lists.selectedCat = response.data.selectedCat
 } else this.history.foundData = []

   this.history.lists.removeList.loading = false
   this.removeCatSelectedModal = false

       })
  })
},

renameCatList(){
  this.history.lists.renameList.loading  = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/change_list.php',{
    method: 'POST',
    data: {
      type: 'rename',
      listName: this.history.lists.selectedCat,
      newName:  this.history.lists.renameList.title ,
    }
  })
  .then( response => {
    this.history.lists.catList[this.history.lists.catList.indexOf(this.history.lists.selectedCat)] = this.history.lists.renameList.title
    this.history.lists.selectedCat = this.history.lists.renameList.title
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/history_get_by_list.php', {
       method: 'POST',
       data : {catList:this.history.lists.catList, selectedCat:this.history.lists.selectedCat },
       }).then(response => {
   this.history.lists.loading = false
   if(response.data.procs){
   this.history.foundData = response.data.procs
   this.history.lists.catList = response.data.catList
   this.history.lists.selectedCat = response.data.selectedCat
 } else this.history.foundData = []
   this.history.lists.renameList.loading = false
   this.history.renameListModal = false

       })
  })
},
       catData(){
           this.history.foundData = []
           axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/history_get_by_list.php', {
              method: 'POST',
              data : {catList:this.history.lists.catList, selectedCat:this.history.lists.selectedCat },
              }).then(response => {
          if(response.data.procs){
          this.history.foundData = response.data.procs
          this.history.lists.catList = response.data.catList
          this.history.lists.selectedCat = response.data.selectedCat
         } else this.history.foundData = []

              })
         },


         getHistory(){
             axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/history_get_by_list.php', {
                method: 'POST',
                data : {catList:this.history.lists.catList, selectedCat:this.history.lists.selectedCat },
                }).then(response => {
            if(response.data.procs){
            this.history.foundData = []
            this.history.foundData = response.data.procs
            this.history.lists.catList = response.data.catList
            this.history.lists.selectedCat = response.data.selectedCat
           } else this.history.foundData = []

                })
           },


       counter(item1){
         let sum = this.history.foundData.map(item=>{
         return item.cat_name.indexOf(item1) > -1
         })
         return sum.filter(item=>{return item}).length
       },


historyClear(){
  this.history.clearAllBtnProcessModal = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/delete_history.php', {
       method: 'POST',
       data: {
         all: 1
       }
     })
     .then( response => {
       this.history.clearAllBtnProcessModal = false
       this.history.foundData = response.data
       this.history.clearAllModal = false
       this.$store.dispatch('changeCounters')
     })
},

 },
 created(){
this.getHistory()
this.updaterInterval =    setInterval( () => {
this.getHistory()
}, 5000)
 },

beforeDestroy(){
  clearInterval(this.updaterInterval)
},


   }
</script>


<style>

</style>
